// 限制只能输入0和正整数（拦截小数点、科学计数法、正负号等字符）
export const blockNonIntegerKey = (e: KeyboardEvent): void => {
  if (['.', ',', '。', 'e', 'E', '-', '+'].includes(e.key)) {
    e.preventDefault()
  }
}
